import React from 'react';
const Step3Pricing = ({ setCurrentStep, handleSubmitStep2, isSubmitting }) => {
   return (
      <div className="modal_content_body fees">
         <h3 className="ppt_form_title mb-5 text-center">Step 2: Pricing & Fees</h3>
         <div className='row justify-content-between'>
            <div className='col-12 col-lg-5' style={{ fontSize: '14px' }}>
               <p><strong>ProperT Platform uses a maker-taker fee schedule with volume incentives based on your activity in the past 30 days.*</strong></p>
               <p style={{fontWeight: '300'}}>Our fee schedules are built to encourage traders to engage with the market and to drive maximum liquidity.</p>
               <p style={{fontWeight: '300'}}>* Volume generated with Instant Buy does not count towards your 30 day volume incentives.</p>
               <p style={{fontWeight: '300'}}>** Institutional clients with 30-day spot crypto volume over $IOOM and activity on Kraken Futures, Kraken Custody or Staked get 0. taker and to exclusive perks.</p>
            </div>
            <div className='col'>
               <table className='table table-borderless' style={{ fontSize: '12px' }}>
                  <thead>
                     <tr>
                        <th>30-day volume (USD)</th>
                        <th>Maker</th>
                        <th>Taker</th>
                     </tr>
                  </thead>
                  <tbody>
                     <tr>
                        <td>More than $0</td>
                        <td>0,25%</td>
                        <td>0,40%</td>
                     </tr>
                     <tr>
                        <td>More then 10.000 $</td>
                        <td>0,20%</td>
                        <td>0,35%</td>
                     </tr>
                     <tr>
                        <td>More than 50.000 $</td>
                        <td>0,14%</td>
                        <td>0,24%</td>
                     </tr>
                     <tr>
                        <td>More then 100.000 $</td>
                        <td>0,12%</td>
                        <td>0,22%</td>
                     </tr>
                     <tr>
                        <td>More than 250.000 $</td>
                        <td>0,10%</td>
                        <td>0,20%</td>
                     </tr>
                     <tr>
                        <td>More then 500.000 $</td>
                        <td>0,08%</td>
                        <td>0,18%</td>
                     </tr>
                     <tr>
                        <td>More then 1.000.000 $</td>
                        <td>0,06%</td>
                        <td>0,16%</td>
                     </tr>
                     <tr>
                        <td>More than 2.500.000 $</td>
                        <td>0,04%</td>
                        <td>0,14%</td>
                     </tr>
                     <tr>
                        <td>More then 5.000.000 $</td>
                        <td>0,02%</td>
                        <td>0,12%</td>
                     </tr>
                     <tr>
                        <td>More than 10.000.000 $</td>
                        <td>0,00%</td>
                        <td>0,10%</td>
                     </tr>
                     <tr>
                        <td>More than 100.000.000 $**</td>
                        <td>0,00%</td>
                        <td>0,08%</td>
                     </tr>
                  </tbody>
               </table>
            </div>
         </div>
         <div className="d-flex justify-content-end gap-3 pt-4 kyc_btns">
            {/* <button onClick={() => setCurrentStep(2)} className="ppt_btn_secondary alt text-dark">Back</button> */}
            <button
               onClick={handleSubmitStep2}
               className="ppt_btn_primary alt"
               disabled={isSubmitting}
            >
               {isSubmitting ? 'Submitting...' : 'Next'}
            </button>
         </div>
      </div>
   );
};
export default Step3Pricing;